import React from 'react';

import {useGetTenantDataQuery} from 'src/containers/User';

import {useGetCompanyDetailsQuery} from './api';
import {validateCompanyDetails} from './thunks';

export const useCheckCompanyDetailsFilled = () => {
  const {data: companyDetails} = useGetCompanyDetailsQuery();
  const {data: tenantData} = useGetTenantDataQuery();

  const isDetailsFilled = React.useMemo(() => {
    if (!companyDetails) {
      return false;
    }

    const isNeedFillCompanyDetails = !validateCompanyDetails(
      companyDetails,
      tenantData?.resellerId,
    );

    return !isNeedFillCompanyDetails;
  }, [companyDetails, tenantData]);

  return isDetailsFilled;
};
